export const createVideoRoom = async (name: string, accountId: number) => {
  const url = `${process.env.REACT_APP_SIGNALLING_API_URL}/accounts/${accountId}/create-video-room`;

  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ roomName: name }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error('There was a problem with the fetch operation:', error);
    throw error;
  }
};
